export default class AdditionalDiscountDTO {
    /**
     * Ідентифікатор рівня знижки:
     *
     * 1 - VIPro1
     *
     * 2 - VIProApp
     *
     * 3 - VIPro2
     *
     * 4 - VIPro3
     *
     * 5 - Повторне замовлення
     *
     * 6 - VIPro
     *
     * 7 - VIPro+
     *
     * 9 - Додаткова знижка для СТО
     *
     * 10 - Додаткова знижка для коштовної запчастини
     *
     * 11 - Знижка для міні-ПРо
     */
    id: number;

    isMainDiscountLevel: boolean;

    percent: number;

    name: string;

    description: string;

    status: string;

    constructor({
        Id = 0,
        IsMainDiscountLevel = false,
        Percent = 0,
        Name = '',
        Description = '',
        Status = ''
    }: {
        Id?: number;
        IsMainDiscountLevel?: boolean;
        Percent?: number;
        Name?: string;
        Description?: string;
        Status?: string;
    } = {}) {
        this.id = Id;
        this.isMainDiscountLevel = IsMainDiscountLevel;
        this.percent = Percent;
        this.name = Name;
        this.description = Description;
        this.status = Status;
    }
}
